import type { LoadingManager, WebGLRenderer } from '@seddi/three';
import type { RecolorContext } from '@seddi/ui-recolor';
import log from 'loglevel';

import { load } from './fabricLoader';
import type { FabricGfx, FabricWithColor } from './fabricTypes';
import { ResourceManager } from './resourceManager';

type Config = { mipmapsHighQuality: boolean; mipmapsUnsharp: boolean };

export class FabricsContext extends ResourceManager<FabricGfx> {
  readonly config: Config;
  readonly manager: LoadingManager;
  readonly recolor: RecolorContext;
  readonly renderer: WebGLRenderer;

  constructor(config: Config, manager: LoadingManager, recolor: RecolorContext, renderer: WebGLRenderer) {
    super();
    this.config = config;
    this.manager = manager;
    this.recolor = recolor;
    this.renderer = renderer;
  }

  async loadAsync(desc: FabricWithColor): Promise<FabricGfx | undefined> {
    if (this.find(desc.id)) {
      log.warn(`FabricsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const fabric = await load(
      desc,
      this.manager,
      this.renderer,
      this.config,
      desc.recolorTarget,
      this.recolor,
    );
    item.status = 'ready';
    item.value = fabric;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Fabric');
    }

    return fabric;
  }
}
